import React from "react";
import styles from "../scss/stripeDocuments.module.scss";

const ReportLayout = ({ children }) => {
  return <div className={styles.reportLayout}>{children}</div>;
};

export default ReportLayout;
